import {
  ProductTypeRefOption,
  RefOption,
  RefOptionWithChildren,
} from "../agenda/types";
import { IRefOptionsService } from "./IRefOptionsService";

export class RefOptionsServiceMock implements IRefOptionsService {
  private mockCodes: string[] = [
    "COUNTRY",
    "DISCOUNT_TYPE",
    "FILE_TYPE",
    "FUR",
    "GENDER",
    "PRODUCT_TYPE",
    "SERVICE_SUB_TYPE",
    "SERVICE_TYPE",
    "SIZE",
    "SLOT_TYPE",
    "SPECIES",
    "SUB_SPECIES",
  ];

  private mockRefOptions: RefOption[] = [
    {
      id: 286,
      code: "COUNTRY",
      value: "Nepal",
      description: "País: Nepal",
      isActive: true,
    },
    {
      id: 287,
      code: "COUNTRY",
      value: "Brazil",
      description: "País: Brazil",
      isActive: true,
    },
    {
      id: 288,
      code: "GENDER",
      value: "Male",
      description: "Género: Macho",
      isActive: true,
    },
    {
      id: 289,
      code: "GENDER",
      value: "Female",
      description: "Género: Hembra",
      isActive: true,
    },
    {
      id: 290,
      code: "SPECIES",
      value: "Dog",
      description: "Especie: Perro",
      isActive: true,
    },
    {
      id: 291,
      code: "SPECIES",
      value: "Cat",
      description: "Especie: Gato",
      isActive: true,
    },
  ];

  async getOptionCodes(): Promise<string[]> {
    await new Promise(resolve => setTimeout(resolve, 500));
    return [...this.mockCodes];
  }

  async getOptionsByCode(code: string): Promise<RefOption[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return this.mockRefOptions.filter(option => option.code === code);
  }

  async getServiceOptions(): Promise<Omit<RefOptionWithChildren, "child">[]> {
    return [];
  }

  async getProductOptions(): Promise<ProductTypeRefOption[]> {
    return [];
  }
}
